import { Input, Form, Typography, Image, Card, FormInstance, Button, Select } from "antd";
import Logo from "../../../../assets/images/Logo_250.png";
import { useEffect, useState } from "react";

export interface Props {
  onChangeCurrentStep: (step: number) => void;
  currentStep: number;
  stepsLength: number;
  form: FormInstance;
  submitFormGeneral: (event: any) => void;
}
const EconnectStepThreePublic: React.FC<Props> = ({ onChangeCurrentStep, currentStep, stepsLength, form, submitFormGeneral }): React.ReactElement => {
  const [valueAttendeeType, setValueAttendeeType] = useState<string>("");
  const [valueFieldofStudy, setValueFieldofStudy] = useState<string>("");
  const [valuePurposeofAttendingS, setValuePurposeofAttendingS] = useState<string>("");
  const [valuePurposeofAttending, setValuePurposeofAttending] = useState<string>("");
  const [valueIndustry, setValueIndustry] = useState<string>("");

  const onChangeSelect = (value: string) => {
    setValueAttendeeType(value);
  };

  const onChangeSelectFieldofStudy = (value: string) => {
    setValueFieldofStudy(value);
  };

  const onChangeSelectPurposeofAttending = (value: string) => {
    setValuePurposeofAttending(value);
  };

  const onChangeSelectPurposeofAttendingS = (value: string) => {
    setValuePurposeofAttendingS(value);
  };

  const onChangeSelectIndustry = (value: string) => {
    setValueIndustry(value);
  };

  return (
    <Card>
      <br />
      <div className="flex justify-center pb-[20px]">
        <Image src={Logo} width={150} preview={false} />
      </div>
      <div className="text-center mt-[5px] pb-[20px]">
        <Typography className="font-bold w-full text-[rgba(84,86,90,1)]">{`Registration Form for check in`}</Typography>
      </div>
      <div>
        <Form form={form} onFinish={submitFormGeneral} layout="vertical" autoComplete="off" className="w-full">
          <Form.Item
            className=" m-1"
            label={"Name-Surname"}
            name={"fullName"}
            rules={[
              {
                required: true,
                message: "Please fill in your name surname!",
              },
            ]}
          >
            <Input placeholder="Text" />
          </Form.Item>
          <Form.Item
            className=" m-1"
            label={"Email"}
            name={"businessEmail"}
            rules={[
              {
                required: true,
                message: "Please fill in your Email!",
              },
            ]}
          >
            <Input placeholder="example@email.com" type="email" />
          </Form.Item>
          <Form.Item
            className=" m-1"
            label={"Telephone"}
            name={"phoneNumber"}
            rules={[
              {
                required: true,
                message: "Please fill in your Telephone!",
              },
            ]}
          >
            <Input placeholder="0XX-XXX-XXXX" />
          </Form.Item>
          <Form.Item
            className=" m-1"
            label={"Attendee Type"}
            name={"attendeeType"}
            rules={[
              {
                required: true,
                message: "Please select Attendee Type!",
              },
            ]}
          >
            <Select
              onChange={onChangeSelect}
              placeholder="Select"
              options={[
                { value: "student", label: "Student" },
                { value: "business", label: "Business Professional" },
                { value: "freelancer", label: "Freelancer" },
                { value: "other", label: "Other" },
              ]}
            />
          </Form.Item>
          <div hidden={valueAttendeeType === "" ? true : false}>
            {valueAttendeeType !== "student" ? (
              <>
                <Form.Item
                  className=" m-1"
                  label={"Company Name (or N/A if not applicable)"}
                  name={"companyName"}
                  rules={[
                    {
                      required: true,
                      message: "Please fill in Company Name!",
                    },
                  ]}
                >
                  <Input placeholder="Enter Company Name" />
                </Form.Item>
                <Form.Item className=" m-1" label={"Industry"} name={"industry"}>
                  <Select
                    onChange={onChangeSelectIndustry}
                    placeholder="Select"
                    options={[
                      { value: "technologyIT", label: "Technology & IT" },
                      { value: "financeBanking", label: "Finance & Banking" },
                      { value: "healthcarePharmaceuticals", label: "Healthcare & Pharmaceuticals" },
                      { value: "marketingAdvertising", label: "Marketing & Advertising" },
                      { value: "creativeDesign", label: "Creative & Design" },
                      { value: "other", label: "Other" },
                    ]}
                  />
                </Form.Item>
                {valueIndustry === "other" && (
                  <Form.Item
                    className=" m-1"
                    label={"Other"}
                    name={"otherIndustry"}
                    rules={[
                      {
                        required: true,
                        message: "Please fill in your Other!",
                      },
                    ]}
                  >
                    <Input placeholder="Text" />
                  </Form.Item>
                )}
                <Form.Item className=" m-1" label={"Position"} name={"position"}>
                  <Input placeholder="Enter Job Title" />
                </Form.Item>
                <Form.Item className=" m-1" label={"Purpose of Attending"} name={"purposeofAttending"}>
                  <Select
                    onChange={onChangeSelectPurposeofAttending}
                    placeholder="Select"
                    options={[
                      { value: "networking", label: "Networking" },
                      { value: "learningDevelopment", label: "Learning & Development" },
                      { value: "businessOpportunities", label: "Business Opportunities" },
                      { value: "other", label: "Other" },
                    ]}
                  />
                </Form.Item>
                {valuePurposeofAttending === "other" && (
                  <Form.Item
                    className=" m-1"
                    label={"Other"}
                    name={"otherPurposeofAttending"}
                    rules={[
                      {
                        required: true,
                        message: "Please fill in your Other!",
                      },
                    ]}
                  >
                    <Input placeholder="Text" />
                  </Form.Item>
                )}
              </>
            ) : (
              <>
                <Form.Item
                  className=" m-1"
                  label={"Institution"}
                  name={"institution"}
                  rules={[
                    {
                      required: true,
                      message: "Please fill in your institution!",
                    },
                  ]}
                >
                  <Input placeholder="Enter University Name" />
                </Form.Item>
                <Form.Item className=" m-1" label={"Field of Study"} name={"fieldofStudy"}>
                  <Select
                    onChange={onChangeSelectFieldofStudy}
                    placeholder="Select"
                    options={[
                      { value: "engineeringTechnology", label: "Engineering & Technology" },
                      { value: "businessFinance", label: "Business & Finance" },
                      { value: "scienceHealthcare", label: "Science & Healthcare" },
                      { value: "artsHumanities", label: "Arts & Humanities" },
                      { value: "other", label: "Other" },
                    ]}
                  />
                </Form.Item>
                {valueFieldofStudy === "other" && (
                  <Form.Item
                    className=" m-1"
                    label={"Other"}
                    name={"otherFieldofStudy"}
                    rules={[
                      {
                        required: true,
                        message: "Please fill in your Other!",
                      },
                    ]}
                  >
                    <Input placeholder="Text" />
                  </Form.Item>
                )}
                <Form.Item className=" m-1" label={"Purpose of Attending"} name={"purposeofAttendingS"}>
                  <Select
                    onChange={onChangeSelectPurposeofAttendingS}
                    placeholder="Select"
                    options={[
                      { value: "networking", label: "Networking" },
                      { value: "learningDevelopment", label: "Learning & Development" },
                      { value: "businessOpportunities", label: "Business Opportunities" },
                      { value: "other", label: "Other" },
                    ]}
                  />
                </Form.Item>
                {valuePurposeofAttendingS === "other" && (
                  <Form.Item
                    className=" m-1"
                    label={"Other"}
                    name={"otherPurposeofAttendingS"}
                    rules={[
                      {
                        required: true,
                        message: "Please fill in your Other!",
                      },
                    ]}
                  >
                    <Input placeholder="Text" />
                  </Form.Item>
                )}
              </>
            )}
          </div>
          <Form.Item>
            <div className="flex justify-center items-center w-full pt-8">
              <div className="flex w-full gap-[5px]">
                {currentStep < stepsLength - 1 && currentStep === 2 && (
                  <div className="w-[300px]">
                    <Button htmlType="submit" type="primary" className="text-white bg-[rgba(10,78,136,1)] w-full rounded-[5px]" size="large">
                      Confirm
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </Form.Item>
        </Form>
      </div>
    </Card>
  );
};
export default EconnectStepThreePublic;
